import { Directive, forwardRef, HostBinding, HostListener, Inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[cdkDetailRow]'
})
export class CdkDetailRowDirective {
  private row: any;
  private tRef: TemplateRef<any>;
  private opened: boolean;
  private _alwaysExpanded: boolean;

  @HostBinding('class.expanded')
  get expended(): boolean {
    return this.opened;
  }

  @Input()
  set cdkDetailRow(value: any) {
    if (value !== this.row) {
      this.row = value;
    }
  }

  @Input('cdkDetailRowTpl')
  set template(value: TemplateRef<any>) {
    if (value !== this.tRef) {
      this.tRef = value;
    }
  }

  @Input('alwaysExpanded')
  set alwaysExpanded(value: boolean) {
    this._alwaysExpanded = value;
    if (value) {
      this.opened = true;
      this.render();
    }
  }

  @Input('initiallyExpanded')
  set initiallyExpanded(value: boolean) {
    if (value) {
      this.opened = true;
      this.render();
    }
  }

  constructor(@Inject(forwardRef(() => ViewContainerRef)) public vcRef: ViewContainerRef) { }

  @HostListener('click')
  onClick(): void {
    if (!this._alwaysExpanded) {
      this.toggle();
    }
  }

  toggle(): void {
    if (this.opened) {
      this.vcRef.clear();
    } else {
      this.render();
    }
    this.opened = this.vcRef.length > 0;
  }

  private render(): void {
    this.vcRef.clear();
    if (this.tRef && this.row) {
      this.vcRef.createEmbeddedView(this.tRef, { $implicit: this.row });
    }
  }
}
